// material-ui
import {} from '@mui/material'
import * as localStorageService from 'components/localStorageService'
import { GetCachedUrls, ResolveStorageUrl } from 'features/firebase-app'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import rq from 'components/RedQuick'
import { SeriesEpisode, SeriesSeason } from 'components/SeriesEpisodesPopup'
import { useBrowserInfo, useLocalId, useStutter } from 'components/utility'
import * as applicationSlice from 'features/application/application-slice'
import * as models from 'models'

import { ResourcePropertyType, Views } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import ApprovedMediaListItemLoaderComponent from 'components/ApprovedMediaListItemLoaderComponent'
import CacheLoad from 'components/CacheLoad'
import MediaPlayerComponent from 'components/MediaPlayerComponent'
import ModelLoader from 'components/ModelLoader'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_approvedMedia } from 'features/approvedMedia/approvedMedia-slice'
import { get_all_approvedSeries } from 'features/approvedSeries/approvedSeries-slice'
import { get_selected_device } from 'features/device/device-slice'
import { get_all_processedMedia } from 'features/processedMedia/processedMedia-slice'
import {
  get_all_profile,
  get_selected_profile,
  setSelectedprofile,
} from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  let profile_list = useSelector(get_all_profile)
  let profile = useSelector(get_selected_profile)
  let processedMedia_list = useSelector(get_all_processedMedia)
  let approvedMedia_list = useSelector(get_all_approvedMedia)
  let approvedSeries_list = useSelector(get_all_approvedSeries)
  let device = useSelector(get_selected_device)
  const [processedMediaId, setProcessedMediaId] = React.useState(null)
  const [prcessedMediaDownloadableUrls, setPrcessedMediaDownloadableUrls] =
    React.useState(null)
  const [quickLoaded, setQuickLoaded] = React.useState(null)
  const [urlUpdated, setUrlUpdated] = React.useState(null)
  const [watchingMediaObject, setWatchingMediaObject] = React.useState(null)
  const [watchingMediaDicArgs, setWatchingMediaDicArgs] = React.useState(null)
  const [previewMetric, setPreviewMetric] = React.useState(null)
  const [previewDicMetric, setPreviewDicMetric] = React.useState(null)
  const [currentSeasonId, setCurrentSeasonId] = React.useState(null)
  const [deviceArgs, setDeviceArgs] = React.useState(null)
  const [profilesLoaded, setProfilesLoaded] = React.useState(null)

  const componentRef: React.Ref<HTMLDivElement> = React.useRef(null)
  const componentRef_size = rq.useContainerSize(componentRef)
  const localDeviceId = useLocalId()
  const watchingMediaArgs = useStutter(
    JSON.stringify(watchingMediaObject),
    5000,
  )
  const browserInfo = useBrowserInfo()
  const watchingMediaDicObject = useStutter(
    JSON.stringify(watchingMediaDicArgs),
    5000,
  )
  const previewDicMetricObject = useStutter(
    JSON.stringify(previewDicMetric),
    5000,
  )

  useEffect(() => {
    function getDownloadableUrl() {
      let stat: models.ProcessedMediaStates = get_media()
      if (stat) {
        ResolveStorageUrl(
          `processed/${stat.mediaId}/media/${stat.id}.${stat.codec}`,
        ).then((resolvedUrl) => {
          console.log(resolvedUrl)
          setPrcessedMediaDownloadableUrls({
            ...(prcessedMediaDownloadableUrls || {}),
            [stat.id]: resolvedUrl,
          })
        })
      }
    }
    getDownloadableUrl()
  }, [get_media()])
  useEffect(() => {
    if (
      claims?.user &&
      false &&
      watchingMediaArgs &&
      watchingMediaObject?.currentTime !== null &&
      watchingMediaObject?.device &&
      watchingMediaObject?.profile
    ) {
      dispatch(
        autoThunks.on_watchings_media({
          userId: claims?.user,
          watchingMediaArgs: (() => {
            function getWatchingMediaArgs(): any {
              return watchingMediaObject
            }
            return getWatchingMediaArgs()
          })(),
        }),
      )
    }
  }, [claims?.user, watchingMediaArgs])
  useEffect(() => {
    if (browserInfo && localDeviceId?.id) {
      function local_device_changes(): any {
        if (localDeviceId?.id && browserInfo) {
          setDeviceArgs({
            ...browserInfo,
            localDeviceId: localDeviceId?.id,
          })
        }
      }
      local_device_changes()
    }
  }, [browserInfo, localDeviceId?.id])
  useEffect(() => {
    if (claims?.user && watchingMediaDicArgs && previewDicMetric) {
      dispatch(
        autoThunks.on_watching_media_complex({
          userId: claims?.user,
          watchingMediaDicArgs: (() => {
            function getWatchingMediaArgs(): any {
              return watchingMediaDicArgs
            }
            return getWatchingMediaArgs()
          })(),
          previewDicMetric: (() => {
            function getpreviewDicMetricObject(): any {
              return previewDicMetric
            }
            return getpreviewDicMetricObject()
          })(),
        }),
      )
    }
  }, [claims?.user, watchingMediaDicObject, previewDicMetricObject])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_next_approved_medias({ userId: claims?.user }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_next_processed_medias({ userId: claims?.user }))
    }
  }, [claims?.user])
  useEffect(() => {
    function routeToProfileSelect(): any {
      if (getLocationPath() === Views.Watch) {
        if (!profile?.id) {
          let data = localStorageService.load('ProfileId')
          if (profilesLoaded) {
            if (data && data.profileId && profilesLoaded?.data?.length) {
              let found_profile = profilesLoaded?.data?.find(
                (v) => v.id === data?.profileId,
              )
              if (found_profile) {
                dispatch(setSelectedprofile(data.profileId))
                dispatch(
                  applicationSlice.setProfileImage(found_profile.profileImage),
                )
                dispatch(applicationSlice.setProfileName(found_profile.name))
              } else {
                navigate(`/${Views.SelectProfile}`, { replace: true })
              }
            } else {
              navigate(`/${Views.SelectProfile}`, { replace: true })
            }
          }
        }
      }
    }
    routeToProfileSelect()
  }, [profile?.id, profile_list?.length])
  useEffect(() => {
    if (claims?.user && getSeriesId() && !isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_series_by_series_id_watch({
          seriesId: (() => {
            function _(): any {
              if (params?.id !== 'inde') return params?.id
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.user, getSeriesId(), !isBrowseMode()])
  useEffect(() => {
    if (claims?.user && getMediaId() && !isBrowseMode()) {
      dispatch(
        autoThunks.get_approved_media_by_media_id_watch({
          mediaId: (() => {
            function _(): any {
              return params?.media
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.user, getMediaId(), !isBrowseMode()])
  useEffect(() => {
    if (claims?.user && claims?.account && deviceArgs) {
      dispatch(
        autoThunks.add_user_device_watch({
          userId: claims?.user,
          deviceArgs: (() => {
            function getDeviceArgs(): any {
              return deviceArgs
            }
            return getDeviceArgs()
          })(),
        }),
      )
    }
  }, [claims?.user, claims?.account, deviceArgs])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.load_profiles_watch({ userId: claims?.user }))
    }
  }, [claims?.user])

  function get_media(): any {
    let mediaItem = processedMedia_list.find(
      (v) => params?.media === v?.mediaId,
    )

    if (!mediaItem) {
      mediaItem = processedMedia_list.find((v) => processedMediaId === v?.id)
    }
    if (mediaItem) {
      let stat = mediaItem?.states
        ?.filter(
          (x) => x.resourcePropertyType === ResourcePropertyType.MediaRel,
        )
        .sort((b, a) => {
          return parseInt(`${a.width}`, 10) - parseInt(`${b.width}`, 10)
        })
        .find((x) => x.mediaRel)
      if (stat) {
        return stat
      }
    }
    return null
  }

  function getMediaUrl(): any {
    let item = get_media()
    if (item && processedMediaId && prcessedMediaDownloadableUrls) {
      return prcessedMediaDownloadableUrls[item?.id] || null
    }
    return null
  }

  function getMediaId(): any {
    return params?.media
  }

  function getSeriesId(): any {
    if (params?.id !== 'inde') return params?.id
  }

  function getSrc(location: string, url: string, size: number) {
    let states: any[] = []
    approvedSeries_list.find((approved_series) => {
      if (approved_series?.processedSeries?.states) {
        states.push(
          ...approved_series?.processedSeries?.states?.filter((st) => {
            let found = st.sourceLocation === location
            return found
          }),
        )
      }
    })
    if (!states.length) {
      approvedMedia_list.find((approved_media) => {
        if (approved_media?.processedMedia?.states) {
          states.push(
            ...approved_media?.processedMedia?.states?.filter((st) => {
              let found = st.sourceLocation === location
              return found
            }),
          )
        }
      })
    }
    if (states.length) {
      states = states.sort((a, b) => {
        return Math.abs(a.width - size) - Math.abs(b.width - size)
      })
      let state = states[0]
      let cached_url = GetCachedUrls(state.location)
      if (!cached_url) {
        ResolveStorageUrl(state.location).then((res) => {
          if (res) {
            setUrlUpdated((urlUpdated || 0) + 1)
          }
        })
      } else {
        return cached_url
      }
    }
    return url
  }

  function getLocationPath(): string {
    if (location.href.indexOf(Views.Watch) !== -1) {
      return Views.Watch
    }
    return ''
  }

  function isBrowseMode(): boolean {
    if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
      return false
    }
    return true
  }

  function main(comp: any): any {
    return (
      <>
        {(() => {
          let temp_media = null
          let seasonNum = 0
          let episodeNum = 0
          let title = ''
          let description = null
          let stat: models.ProcessedMediaStates = get_media()
          let url = getMediaUrl()
          let asi = approvedSeries_list.find((v) => v.id === params?.id)
          let ami = approvedMedia_list.find(
            (v) => v.id === params?.approvedMedia,
          )
          let seasons: SeriesSeason[] = []
          let episodes: SeriesEpisode[] = []
          let currentSeason: string = ''
          let series = null
          let currentEpisode: string = ''
          if (params?.id === 'inde') {
            console.log(params)
            let asi = approvedMedia_list.find((v) => v.media === params?.media)
            if (asi) {
              title = asi?.media?.description?.nameDefault
              description = asi?.media?.description?.descriptionDefault
            }
          } else if (params?.id === asi?.id) {
            console.log(params)
            title = asi?.series?.name
            series == asi?.series
            currentEpisode = ami?.mediaId || stat?.mediaId
            asi?.seasons?.filter((v, season_index: number) => {
              seasons.push({
                id: v.id,
                name: v.name,
                episodes: [],
              })
              temp_media =
                temp_media ||
                v.media
                  .map((m) => {
                    episodes.push({
                      id: m.id,
                      description: m.description.descriptionDefault,
                      episodeNumber: 0,
                      name: m.description.nameDefault,
                      thumbnail: m.thumbnail,
                    })
                    seasons[seasons.length - 1].episodes.push(m.id)
                    return m
                  })
                  .find((y, episode_index: number) => {
                    let found = y.id === (params?.media || stat?.mediaId)
                    if (found) {
                      episodeNum = episode_index
                    }
                    return found
                  })
              if (seasonNum === 0 && temp_media) {
                seasonNum = season_index
                currentSeason = v.id
              }
              return temp_media
            })
          }

          let backgroundImage = getSrc(
            asi?.series?.titleMediaImageLocation || '',
            asi?.series?.titleMediaImageUrl || '',
            componentRef_size?.width || 1920,
          )
          return (
            <>
              <ApprovedMediaListItemLoaderComponent
                onProcessedMedia={($proccessedMedia) => {
                  setProcessedMediaId($proccessedMedia?.id)
                }}
              />
              {url && (
                <CacheLoad>
                  <>
                    <ModelLoader />
                    <MediaPlayerComponent
                      title={title || temp_media?.description?.nameDefault}
                      currentSeason={currentSeason}
                      currentEpisode={currentEpisode}
                      episodeTitle={
                        description || temp_media?.description?.nameDefault
                      }
                      seasonNumber={seasonNum + 1}
                      episodeNumber={episodeNum + 1}
                      seasons={seasons}
                      backgroundImage={backgroundImage}
                      series={asi}
                      approvedMedia={approvedMedia_list}
                      processedMedia={processedMedia_list}
                      episodes={episodes}
                      url={url}
                      onPlay={(eps: SeriesEpisode) => {
                        if (eps?.id === undefined) {
                          navigate(`/${Views.Browse}`, { replace: true })
                        } else {
                          let approvedMediaItem = approvedMedia_list.find(
                            (x) => x.mediaId === eps?.id,
                          )
                          if (approvedMediaItem) {
                            navigate(
                              `/${Views.Watch}/${asi?.id}/${approvedMediaItem?.mediaId}/${approvedMediaItem?.id}`,
                              {
                                replace: true,
                              },
                            )
                          }
                        }
                      }}
                      onPlaying={(args) => {
                        setWatchingMediaDicArgs({
                          ...(watchingMediaDicArgs || {}),
                          [params?.media || stat?.mediaId]: {
                            ...browserInfo,
                            ...args,
                            device: device?.id,
                            profile: profile?.id,
                            series: asi?.series?.id,
                            media: params?.media || stat?.mediaId,
                          },
                        })
                        let viewedSections = []
                        if (
                          previewDicMetric &&
                          previewDicMetric[params?.media || stat?.mediaId]
                        ) {
                          viewedSections =
                            previewDicMetric[params?.media || stat?.mediaId]
                              .viewedSections
                        } else {
                          viewedSections = new Array(100).fill(0)
                        }
                        if (args.duration) {
                          let index = Math.round(
                            (100 * args.currentTime) / args.duration,
                          )
                          viewedSections[index] = 1
                          if (args.duration < 100) {
                            if (index > 0) {
                              viewedSections[index - 1] = 1
                            }
                            if (index < 99) {
                              viewedSections[index + 1] = 1
                            }
                          }
                          setPreviewDicMetric({
                            ...(previewDicMetric || {}),
                            [params?.media || stat?.mediaId]: {
                              seriesId: asi?.series?.id,
                              mediaId: params?.media || stat?.mediaId,
                              profileId: profile?.id,
                              viewedSections: [...viewedSections],
                              currentPosition: args.currentTime / args.duration,
                            },
                          })
                        }
                      }}
                      onChangeSeason={(seasonId) => {
                        setCurrentSeasonId(seasonId)
                      }}
                      onVideoStateChange={(args: any) => {
                        let stat: models.ProcessedMediaStates = get_media()
                        setWatchingMediaObject({
                          ...browserInfo,
                          ...args,
                          device: device?.id,
                          profile: profile?.id,
                          isMobile: false,
                          media: stat.mediaId,
                        })
                      }}
                    />
                  </>
                </CacheLoad>
              )}{' '}
            </>
          )
        })()}
      </>
    )
  }

  let output_main = main(null)

  return output_main
}
